module.exports = __webpack_public_path__ + "static/article-image-02-7507267ba5e08628ad973a8c79bb3df4.jpg";